<template>
  <q-page padding>
    <div class="col-xs-12 col-sm-8">
      <p class="text-h6 text-weight-bold text-brand-5 texto-titulo">
        Status Treinamento Consolidado
      </p>
    </div>
    <div
      class="row col-12 q-gutter-sm text-brand-5 text-weight-bold q-mt-md container-inputs"
    >
      <div class="col-md-2 col-sm-5 col-xs-5">
        <div class="q-ml-sm texto-titulo-input">Unidade</div>

        <lista-unidades-select v-model="unidade.nome"></lista-unidades-select>
      </div>
      <div class="col-md-2 col-sm-6 col-xs-6">
        <div class="q-ml-sm texto-titulo-input">Nome do Treinamento</div>
        <q-input
          v-model="filtros.nomeTreinamento"
          dense
          outlined
          label="Digite o nome do Treinamento"
          class="input"
        />
      </div>
      <div class="col-md-2 col-sm-6 col-xs-6">
        <div class="q-ml-sm texto-titulo-input">Nome do Funcionário</div>

        <SelecaoSolicitante
          :label="'Pesquise o Funcionario'"
          @emitirFuncionario="receberFuncionario"
        />
      </div>
      <div class="col-md-3 col-sm-5 col-xs-5">
        <div class="q-ml-sm texto-titulo-input">Status</div>
        <q-select
          v-model="filtros.status"
          label="Selecione o Status"
          multiple
          :options="optionsStatus"
          dense
          outlined
          class="input"
        />
      </div>
      <div class="col-md-2 col-sm-5 col-xs-5">
        <div class="q-ml-sm texto-titulo-input">Vence Em</div>
        <q-input
          v-model="filtros.validade"
          dense
          outlined
          class="input"
          placeholder="Dias"
        />
      </div>
      <div class="col-md-2 col-sm-6 col-xs-6">
        <div class="q-ml-sm texto-titulo-input">GHE</div>

        <div class="col-md-4">
          <q-select
            outlined
            dense
            v-model="filtros.funcionarioGhe"
            :options="funcoes"
            option-value="id"
            label="Digite o GHE"
            behavior="menu"
            map-options
            use-input
            option-label="name"
            @filter="filtrarGhe"
          >
          </q-select>
        </div>
      </div>
      <div class="col-md-2 col-sm-6 col-xs-6">
        <div class="q-ml-sm texto-titulo-input">Centro de Custo</div>

        <q-select
          v-model="filtros.centroCusto"
          option-label="name"
          option-value="code"
          label-color="grey-6"
          label="Pesquise o Centro de Custo"
          :options="centroOptions"
          dense
          outlined
          input-debounce="0"
          @filter="filtrarCentro"
          use-input
        />
      </div>
      <div class="col-md-2 col-sm-5 col-xs-5">
        <div class="q-ml-sm texto-titulo-input">Cargo</div>
        <q-input
          v-model="filtros.funcionarioCargo"
          dense
          outlined
          label="Digite o Cargo"
          class="input"
        />
      </div>
      <div>
        <p></p>
        <q-btn
          class="q-mt-sm"
          icon="filter_alt"
          color="primary"
          label="Filtrar"
          no-caps
          @click="atualizarTabelas()"
        />
      </div>
    </div>
    <div class="q-mt-xl">
      <div class="row col-12 q-my-lg justify-between items-center">
        <span
          class="texto-titulo-tabela text-brand-5 text-subtitle1 text-weight-bold"
        >
          Treinamentos
        </span>
      </div>
      <q-table
        color="primary"
        table-header-class="bg-accent text-weight-bold"
        flat
        :pagination="initialPagination"
        :rows="dadosTreinamento"
        dense
        :columns="columns"
        class="tabela-tamanho-fixo"
        :grid="$q.screen.lt.sm"
      >
        <template v-slot:item="props">
          <div class="col-xs-12 col-sm-6 col-md-4 q-mb-md">
            <div class="row card text-grid-table text-brand-5 q-pa-sm">
              <div
                class="row col-12 justify-center items-center justify-between"
              >
                <div class="col-7">
                  <div class="row col-12 q-ml-sm q-mt-sm">
                    <span class="q-mr-sm"
                      ><strong class="q-mr-xs">Nome: </strong>
                      {{ props.row.treinamentoNome }}</span
                    >
                  </div>
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Descrição: </strong>
                    {{ props.row.treinamentoDescricao }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Validade: </strong>
                    {{
                      props.row.treinamentoValidade
                        ? props.row.treinamentoValidade > 0
                          ? props.row.treinamentoValidade + " Dias"
                          : " Dia"
                        : ""
                    }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Funcionários Associados: </strong>
                    {{ props.row.funcionariosAssociados }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Funcionários Vencidos: </strong>
                    {{ props.row.funcionariosVencidos }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Funcionários Válidos: </strong>
                    {{ props.row.funcionariosValidos }}</span
                  >
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:body-cell-nome="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.treinamentoNome }}
          </q-td>
        </template>
        <template v-slot:body-cell-descricao="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.treinamentoDescricao }}
          </q-td>
        </template>
        <template v-slot:body-cell-validade="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{
              props.row.treinamentoValidade
                ? props.row.treinamentoValidade > 0
                  ? props.row.treinamentoValidade + " Dias"
                  : " Dia"
                : ""
            }}
          </q-td>
        </template>
        <template v-slot:body-cell-funcionariosAssociados="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.funcionariosAssociados }}
          </q-td>
        </template>
        <template v-slot:body-cell-funcionariosVencidos="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.funcionariosVencidos }}
          </q-td>
        </template>
        <template v-slot:body-cell-funcionariosValidos="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.funcionariosValidos }}
          </q-td>
        </template>
      </q-table>
    </div>
    <div class="q-mt-xl">
      <div class="row col-12 q-my-lg justify-between items-center">
        <span
          class="texto-titulo-tabela text-brand-5 text-subtitle1 text-weight-bold"
        >
          Funcionários
        </span>
      </div>
      <q-table
        color="primary"
        table-header-class="bg-accent text-weight-bold"
        flat
        :pagination="initialPagination2"
        :rows="dadosFuncionario"
        :columns="columns2"
        class="tabela-tamanho-fixo"
        dense
        :grid="$q.screen.lt.sm"
        :rows-per-page-options="[0]"
      >
        <template v-slot:item="props">
          <div class="col-xs-12 col-sm-6 col-md-4 q-mb-md">
            <div class="row card text-grid-table text-brand-5 q-pa-sm">
              <div
                class="row col-12 justify-center items-center justify-between"
              >
                <div class="col-7">
                  <div class="row col-12 q-ml-sm q-mt-sm">
                    <span class="q-mr-sm"
                      ><strong class="q-mr-xs">Nome: </strong>
                      {{ props.row.funcionarioNome }}</span
                    >
                  </div>
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">SAP: </strong>
                    {{ props.row.funcionarioSap }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Email: </strong>
                    {{ props.row.funcionarioEmail }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Função: </strong>
                    {{ props.row.funcionarioFuncao }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Cargo: </strong>
                    {{ props.row.funcionarioCargo }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Treinamentos Associados: </strong>
                    {{ props.row.treinamentosAssociados }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Treinamentos Válidos: </strong>
                    {{ props.row.treinamentosValidos }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Treinamentos Vencidos: </strong>
                    {{ props.row.treinamentosVencidos }}</span
                  >
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:body-cell-nome="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.funcionarioNome }}
          </q-td>
        </template>
        <template v-slot:body-cell-sap="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.funcionarioSap }}
          </q-td>
        </template>
        <template v-slot:body-cell-email="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.funcionarioEmail }}
          </q-td>
        </template>
        <template v-slot:body-cell-funcao="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.funcionarioFuncao }}
          </q-td>
        </template>
        <template v-slot:body-cell-cargo="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.funcionarioCargo }}
          </q-td>
        </template>
        <template v-slot:body-cell-centroCusto="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.centroCustoNome }}
          </q-td>
        </template>
        <template v-slot:body-cell-treinamentosAssociados="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.treinamentosAssociados }}
          </q-td>
        </template>
        <template v-slot:body-cell-treinamentosValidos="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.treinamentosValidos }}
          </q-td>
        </template>
        <template v-slot:body-cell-treinamentosVencidos="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.treinamentosVencidos }}
          </q-td>
        </template>
      </q-table>
    </div>
    <div class="row col-12 q-mt-xl">
      <BarChart
        :labels="dadosGrafico.labels"
        :datasets="dadosGrafico.datasets"
        :atualizar="atualizar"
      />
    </div>
  </q-page>
</template>

<script>
import { useStore } from "vuex";
import { onMounted, ref, watch } from "vue";

import BarChart from "../components/BarChart.vue";
import ListaUnidadesSelect from "../../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import SelecaoSolicitante from "../components/SelecaoSolicitante.vue";
const columns = [
  {
    name: "nome",
    label: "Nome",
    align: "left",
  },
  {
    name: "descricao",
    label: "Descrição",
    align: "left",
  },
  {
    name: "funcionariosAssociados",
    label: "Funcionários Associados",
    align: "left",
  },
  {
    name: "funcionariosVencidos",
    label: "Funcionários Vencidos",
    align: "left",
  },
  {
    name: "funcionariosValidos",
    label: "Funcionários Válidos",
    align: "left",
  },
];
const columns2 = [
  {
    name: "nome",
    label: "Nome",
    align: "left",
  },
  {
    name: "sap",
    label: "SAP",
    align: "left",
  },
  {
    name: "email",
    label: "Email",
    align: "left",
  },
  {
    name: "funcao",
    label: "Função",
    align: "left",
  },
  {
    name: "cargo",
    label: "Cargo",
    align: "left",
  },
  {
    name: "centroCusto",
    label: "Centro de Custo",
    align: "left",
  },
  {
    name: "treinamentosAssociados",
    label: "Treinamento Associados",
    align: "left",
  },
  {
    name: "treinamentosVencidos",
    label: "Treinamentos Vencidos",
    align: "left",
  },
  {
    name: "treinamentosValidos",
    label: "Treinamentos Válidos",
    align: "left",
  },
];
export default {
  components: { BarChart, ListaUnidadesSelect, SelecaoSolicitante },
  setup() {
    const store = useStore();

    let unidade = ref({
      nome: store.state.org.unidadeData,
      id: store.state.org.unidadeData.id,
    });
    const optionsStatus = [
      {
        label: "Vencidos",
        value: "vencido",
      },
      {
        label: "Válidos",
        value: "valido",
      },
    ];
    const filtros = ref({
      status: [],
      nomeTreinamento: "",
      funcionario: "",
      funcionarioGhe: "",
      funcionarioCargo: "",
      centroCusto: "",
      validade: "",
    });
    const centroOptions = ref([]);
    const time = ref(null);
    const solicitanteMatricula = ref(null);
    const funcoes = ref([]);
    const dadosFuncionario = ref([]);
    const dadosTreinamento = ref([]);
    const dadosGrafico = ref({
      labels: [],
      datasets: [
        {
          label: "Associados",
          data: [],
          backgroundColor: ["#FDFF00"],
        },
        {
          label: "Vencidos",
          data: [],
          backgroundColor: ["#FF0303"],
        },
        {
          label: "Válidos",
          data: [],
          backgroundColor: ["#2B7A0B"],
        },
      ],
    });
    let atualizar = ref(0);

    const dadosConsolidadosTreinamento = async () => {
      await unidade.value.id;
      try {
        const response = await store.dispatch(
          "treinamento/dadosConsolidadosTreinamento",
          {
            unidadeId: unidade.value.id,
            funcionario: filtros.value?.funcionario?.name,
            funcionarioGhe: filtros.value?.funcionarioGhe?.name,
            funcionarioCargo: filtros.value.funcionarioCargo,
            centroCusto: filtros.value?.centroCusto?.name,
            treinamento: filtros.value.nomeTreinamento,
            validade: filtros.value.validade,
          }
        );

        dadosTreinamento.value = await response.data;

        dadosGrafico.value.labels = [];
        dadosGrafico.value.datasets[0].data = [];
        dadosGrafico.value.datasets[1].data = [];
        dadosGrafico.value.datasets[2].data = [];
        dadosTreinamento.value.forEach((treinamento) => {
          dadosGrafico.value.labels.push(treinamento.treinamentoNome);
          dadosGrafico.value.datasets[0].data.push(
            treinamento.funcionariosAssociados
          );
          dadosGrafico.value.datasets[1].data.push(
            treinamento.funcionariosVencidos
          );
          dadosGrafico.value.datasets[2].data.push(
            treinamento.funcionariosValidos
          );
        });
        atualizar.value++;
      } catch (error) {
        console.log(error);
      }
    };

    const dadosConsolidadosFuncionario = async () => {
      await unidade.value.id;
      try {
        const response = await store.dispatch(
          "treinamento/dadosConsolidadosFuncionario",
          {
            unidadeId: unidade.value.id,
            funcionario: filtros.value?.funcionario?.name,
            funcionarioGhe: filtros.value?.funcionarioGhe?.name,
            funcionarioCargo: filtros.value.funcionarioCargo,
            centroCusto: filtros.value?.centroCusto?.name,
            treinamento: filtros.value.nomeTreinamento,
            validade: filtros.value.validade,
          }
        );
        dadosFuncionario.value = response.data;
      } catch (error) {
        console.log(error);
      }
    };

    const atualizarTabelas = () => {
      dadosConsolidadosFuncionario();
      dadosConsolidadosTreinamento();
    };

    const getFunctions = async (value) => {
      let response = await store.dispatch("user/getFuncoes", {
        vendor_id: store.state.org.unidadeData.id,
        search: value,
      });
      funcoes.value = response.data.results.data;
    };

    const getCentros = async (val) => {
      const response = await store.dispatch("pkg/getCentrosCustos", {
        search: val,
      });

      centroOptions.value = response.data.results.data;
    };

    const receberFuncionario = (value) => {
      filtros.value.funcionario = value;
    };

    watch(
      () => store.state.org.unidadeData,
      () => {
        unidade.value.nome = store.state.org.unidadeData;
        unidade.value.id = store.state.org.unidadeData.id;
        dadosConsolidadosTreinamento();
        dadosConsolidadosFuncionario();
      }
    );

    const getUnidade = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        unidade.value.nome = JSON.parse(getunidade);
      }
    };

    onMounted(getUnidade);

    onMounted(dadosConsolidadosTreinamento);
    onMounted(dadosConsolidadosFuncionario);

    return {
      columns,
      columns2,
      unidade,
      dadosConsolidadosTreinamento,
      optionsStatus,
      filtros,
      dadosTreinamento,
      dadosConsolidadosFuncionario,
      dadosFuncionario,
      dadosGrafico,
      atualizar,
      receberFuncionario,
      solicitanteMatricula,
      initialPagination: {
        sortBy: "desc",
        descending: false,
        page: 1,
        rowsPerPage: 10,
        // rowsNumber: xx if getting data from a server
      },
      initialPagination2: {
        sortBy: "desc",
        descending: false,
        page: 1,
        rowsPerPage: 10,
        // rowsNumber: xx if getting data from a server
      },
      atualizarTabelas,
      funcoes,
      centroOptions,
      filtrarCentro(val, update, abort) {
        clearTimeout(time.value);
        if (val.length < 1) {
          abort();
          return;
        }

        time.value = setTimeout(() => {
          getCentros(val);
        }, 2000);

        setTimeout(() => {
          update();
        }, 2500);
      },
      filtrarGhe(val, update) {
        getFunctions(val);
        setTimeout(() => {
          update();
        }, 500);
      },
    };
  },
};
</script>

<style scoped>
@media (max-width: 600px) {
  .texto-titulo {
    font-size: 14px;
    margin-top: 10px;
  }
  .container-inputs {
    margin: 0px 0px 0px 0px;
  }
  .texto-titulo-input {
    font-size: 12px;
    margin: 0px;
  }

  .input {
    font-size: 12px;
  }
  .texto-titulo-tabela {
    margin: 0px 0px 0px 6px;
    font-size: 12px;
  }
  .select {
    font-size: 12px;
  }
  .card {
    border: 1px solid #707070;
    border-radius: 5px;
  }
  .text-grid-table {
    font-size: 12px;
  }
}
</style>
